import { AxiosError } from 'axios';
export type AxiosErrorHandlerResponse = {
    data: null;
    status: 999;
    statusText: string;
    headers: {};
    config: {};
}

export function AxiosErrorHandler(error: AxiosError): AxiosErrorHandlerResponse {
    return {
        status: 999,
        statusText: "Network Error",
        data: null,
        headers: {},
        config: {},
    };
}

export function isAxiosError(arg: any): arg is AxiosErrorHandlerResponse {
    return arg.status >= 400;
}